import { render, staticRenderFns } from "./deleteReserveCatalog.vue?vue&type=template&id=0b827e4f&scoped=true"
import script from "./deleteReserveCatalog.vue?vue&type=script&lang=js"
export * from "./deleteReserveCatalog.vue?vue&type=script&lang=js"
import style0 from "./deleteReserveCatalog.vue?vue&type=style&index=0&id=0b827e4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b827e4f",
  null
  
)

export default component.exports